import { Button, IconButton, StepButton, useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";
import Step from "@mui/material/Step";
import Stepper from "@mui/material/Stepper";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetData } from "../../features/data/data.slice";
import {
  completeStep,
  resetSteps,
  updateStep,
} from "../../features/stepper.slice";

import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAltOutlined";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Rating from "@mui/material/Rating";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { useGA4React } from "ga-4-react";
import PropTypes from "prop-types";
import {
  getSubmition,
  resetSubmition,
} from "../../features/submition/submition.slice";
import PrimaryButton from "./buttons/primaryButton";

import { yupResolver } from "@hookform/resolvers/yup";
import { makeStyles } from "@mui/styles";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { sendReview } from "../../features/notification/notification.slice";
import { sendFeedback } from "../../features/rating/rating.slice";

import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import CircularProgress, {
  circularProgressClasses,
} from "@mui/material/CircularProgress";
import {
  clearAlertWithDelay,
  setAlertError,
} from "../../features/alert/alert.slice";
import { resetFiles } from "../../features/fileUpload/fileUpload.slice";
import { resetUser } from "../../features/user/user.slice";
import SaveProcess from "../dialogs/saveProcess";
import { Report } from "../../libs/loggers";

const StyledRating = styled(Rating)(({ theme }) => ({
  "& .MuiRating-iconEmpty .MuiSvgIcon-root": {
    color: theme.palette.action.disabled,
  },

  marginTop: "10px",
  marginBottom: "10px",
  width: "fit-content",
}));

const useStyles = makeStyles((theme) => ({
  backDrop: {
    backdropFilter: "blur(3px)",
    backgroundColor: "rgba(0,0,0,0.4)",
  },
  root: {
    textAlign: "center",
    margin: theme.spacing(2),
  },
  circle: {
    strokeLinecap: "round",
  },
}));

export default function InvestNowStepper(props) {
  const dispatch = useDispatch();
  const stepper = useSelector((state) => state.stepper.value);
  const selectedVehicle = useSelector((state) => state.data.value.vehicle);
  const navigate = useNavigate();
  const ga4 = useGA4React();
  const theme = useTheme();
  const classes = useStyles();
  const isDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [confirmResetOpen, setConfirmResetOpen] = useState(false);
  const [finishDialogOpen, setFinishDialogOpen] = useState(false);
  const [couldComplete, setcouldComplete] = useState(true);
  const [thankYouDialogOpen, setThankYouDialogOpen] = useState(false);
  const [stepsToImprove, setStepsToImprove] = useState(false);
  const [rating, setRating] = useState();
  const [couldCompleteMessage, setcouldCompleteMessage] = useState("");
  const [stepsToImproveMessage, setStepsToImproveMessage] = useState("");
  const [finalDialogText, setFinalDialogText] = useState("");
  const [confirmUnload, setConfirmUnload] = useState(false);
  const requireHelp = useSelector((state) => state.stepper.value.requireHelp);
  const submitionId = useSelector((state) => state.submition.data?._id);
  const submitionData = useSelector((state) => state.submition.data);
  const logEvent = (action, label, category) => {
    ga4.event(action, label, category);
  };
  let page = window.location.pathname.replace(/^\/|\/$/g, "");

  const formStepperSteps = useSelector(
    (state) => state.formStepper.value.formSectionsSteps
  );
  const userId = useSelector((state) => state.submition.data?.userId);

  const showButtons = () => {
    const step3help = stepper.active == 2 && requireHelp;
    if (stepper.active <= 0 || step3help) {
      return false;
    } else {
      return true;
    }
  };
  const totalSteps = () => {
    return stepper.steps.length;
  };

  const completedSteps = () => {
    return stepper.steps.filter((s) => s.completed).length;
  };

  const isLastStep = () => {
    return stepper.active === totalSteps() - 1;
  };

  const submitting = useSelector((state) => state.submition.submition?.loading);

  const creatingSecureProcess = useSelector(
    (state) => state.submition.submition?.secureProcessLoading
  );

  const ratingLoading = useSelector((state) => state.rating.rating.loading);

  const validationSchema = yup.object().shape({
    couldComplete: yup.boolean().required(),
    stepsToImprove: yup.boolean().required(),
    star: yup.number().required(""),
    couldNotComplete: yup.string().when("couldComplete", {
      is: false,
      then: yup.string().required(""),
    }),
    improvements: yup.string().when("stepsToImprove", {
      is: true,
      then: yup.string().required(""),
    }),
  });
  const newActiveStep = !isLastStep() ? stepper.active + 1 : 0;
  const {
    register,
    trigger,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    mode: ["all"],
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    register("stepsToImprove");
    register("couldComplete");
    register("shouldValidate");
    register("star");
  }, []);

  useEffect(() => {
    setValue("stepsToImprove", stepsToImprove);
  }, [stepsToImprove]);

  useEffect(() => {
    setValue("couldComplete", couldComplete);
  }, [couldComplete]);

  useEffect(() => {
    setValue("star", rating);
  }, [rating]);

  useEffect(() => {
    if (!requireHelp && !userId && stepper.active >= 2) {
      const handleBeforeUnload = (e) => {
        e.preventDefault();
        e.returnValue = "";
        setConfirmUnload(true);
      };

      const handleUnload = (e) => {
        setConfirmUnload(false);
      };

      window.addEventListener("beforeunload", handleBeforeUnload);

      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }
  }, [stepper.active]);

  const closeSave = () => {
    setConfirmUnload(false);
  };

  const incompleteStep = formStepperSteps.findIndex(
    (x) => x.completed === false
  );
  const lastFormStep = formStepperSteps.length - 1;

  const shouldLoad = () => {
    const isFinalStep = incompleteStep == formStepperSteps.length;

    if ((isFinalStep && submitting) || (isFinalStep && creatingSecureProcess)) {
      return true;
    } else {
      return false;
    }
  };
  const shouldSubmit = () => {
    if (stepper.active == 3) {
      if (incompleteStep == -1 || incompleteStep < lastFormStep) {
        dispatch(setAlertError("Please complete all the steps"));
        dispatch(clearAlertWithDelay());
      }
      return incompleteStep >= lastFormStep;
    } else {
      return true;
    }
  };

  const handleNext = async () => {
    const isValid = await props.checkValidation();
    const newStep = stepper.active + 1;
    const eventInfo = {
      action: "click",
      category: "guidance",
      description: "clicked next",
      value: {
        prevPage: page,
        step: stepper.active + 1,
        value: isLastStep() ? "finish" : "next",
      },
    };

    if (isValid) {
      if (!isLastStep()) {
        if (shouldSubmit()) {
          props.onNext();
          Report(eventInfo, userId, submitionId);
          dispatch(updateStep(newActiveStep));
          handleComplete();
          navigate(stepper.steps[newActiveStep].url);
          logEvent(
            "next_step",
            stepper.steps[newActiveStep].name,
            `Step ${newActiveStep + 1}`
          );
        }
      } else if (isLastStep()) {
        handleFinishDialogOpen();
      }
    }
  };

  const handleBack = () => {
    const prevPage = stepper.active - 1;
    const eventInfo = {
      action: "click",
      category: "guidance",
      description: "clicked back",
      value: {
        currentPage: page,
        prevPage: prevPage,
        step: stepper.active + 1,
        value: "back",
      },
    };

    Report(eventInfo, userId, submitionId);
    dispatch(updateStep(stepper.active - 1));
    navigate(stepper.steps[stepper.active - 1].url);
    logEvent(
      "prev_step",
      stepper.steps[stepper.active - 1].name,
      `Step ${stepper.active - 1}`
    );
  };

  const handleStep = (step) => () => {
    dispatch(updateStep(step));
    navigate(stepper.steps[step].url);
  };

  const handleComplete = () => {
    dispatch(completeStep(stepper.active));
  };

  const handleReset = () => {
    navigate(stepper.steps[0].url);
    dispatch(resetSteps());
  };

  const handleCloseThankYouDialog = () => {
    setThankYouDialogOpen(false);
  };

  const handleStartOver = () => {
    setConfirmResetOpen(true);
  };

  const handleCloseReset = () => {
    setConfirmResetOpen(false);
  };

  const submitRating = async () => {
    const isValid = await trigger();
    const newStep = stepper.active + 1;
    let submitionDetails;
    const feedback = {};
    const eventInfo = {
      action: "submit",
      category: "rating",
      description: "submited rating",
      value: {
        prevPage: page,
        step: stepper.active + 1,
        value: "next",
        email: submitionData.email,
      },
    };

    if (submitionId) {
      submitionDetails = await dispatch(getSubmition(submitionId));
      feedback.name = submitionDetails.payload.data.firstName;
      feedback.surname = submitionDetails.payload.data.surname;
      feedback.email = submitionDetails.payload.data.email;
      feedback.phone = submitionDetails.payload.data.cell;
      feedback.dateOfBirth = submitionDetails.payload.data.dateOfBirth;
      feedback.gender = submitionDetails.payload.data.gender;
      feedback.occupation = submitionDetails.payload.data.occupation;
      feedback.vehicle = selectedVehicle;
      feedback.star = rating;
      feedback.couldComplete = couldComplete;
      feedback.couldCompleteMessage = couldCompleteMessage;
      feedback.stepsToImprove = stepsToImprove;
      feedback.stepsToImproveMessage = stepsToImproveMessage;
    }

    if (
      (isValid && feedback.star && feedback.star > 0) ||
      (feedback.couldCompleteMessage &&
        feedback.couldCompleteMessage.length > 0) ||
      (feedback.stepsToImproveMessage &&
        feedback.stepsToImproveMessage.length > 0) ||
      feedback.couldComplete === false ||
      feedback.stepsToImprove
    ) {
      if (isValid) {
        dispatch(sendFeedback(feedback)).then((res) => {
          dispatch(sendReview(feedback)).then((res) => {
            res.payload?.success && setThankYouDialogOpen(true);
            setFinishDialogOpen(false);
            setFinalDialogText("Thank your for your feedback");
            Report(eventInfo, userId, submitionId);
          });
        });
      }
    } else if (isValid) {
      setFinishDialogOpen(false);
      setFinalDialogText("Thank you for your feedback");
      setThankYouDialogOpen(true);
    }
  };

  const handleConfirmReset = (props) => {
    logEvent(
      "reset",
      stepper.steps[stepper.active].name,
      `Step ${stepper.active}`
    );
    const over = props.startAnother ? "another" : "over";

    const eventInfo = {
      action: "click",
      category: "guidance",
      description: `clicked start ${over}`,
      value: {
        nextPage: stepper.steps[0].url,
        prevPage: page,
        step: stepper.active + 1,
        value: `start_${over}`,
      },
    };

    Report(eventInfo, userId, submitionId);
    navigate(stepper.steps[0].url);
    dispatch(resetSubmition());
    dispatch(resetData());
    dispatch(resetSteps());
    dispatch(resetFiles());
    dispatch(resetUser());
    setConfirmResetOpen(false);
  };

  const goToWebsite = () => {
    const newStep = stepper.active + 1;
    const eventInfo = {
      action: "click",
      category: "guidance",
      description: "clicked go to website",
      value: {
        nextPage: stepper.steps[newStep].url,
        prevPage: page,
        step: stepper.active + 1,
        value: "go_to_site",
      },
    };
    Report(eventInfo, userId, submitionId);
  };

  const handleFinishDialogOpen = () => {
    setFinishDialogOpen(true);
    logEvent(
      "finish",
      stepper.steps[stepper.active].name,
      `Step ${stepper.active}`
    );
    const eventInfo = {
      action: "click",
      category: "finish",
      description: "clicked finish",
      value: {
        prevPage: page,
        step: stepper.active + 1,
        value: "finish",
      },
    };
    Report(eventInfo, userId, submitionId);
  };

  const handleFinishDialogClose = () => {
    setFinalDialogText("Where would you like to navigate to next");
    setThankYouDialogOpen(true);
    setFinishDialogOpen(false);
  };

  const activeStep = stepper.active + 1;

  const stepPercent = (activeStep / stepper.steps.length) * 100;

  const handleToWebsite = () => {
    //Dispatch action to reset stepper, submit ratings and navigate to website

    window.open("https://fairtree.com/education/");
  };

  const customIcons = {
    1: {
      icon: (
        <SentimentVeryDissatisfiedIcon
          sx={{ fontSize: "35px" }}
          color="error"
        />
      ),
      label: "Very Dissatisfied",
    },
    2: {
      icon: (
        <SentimentDissatisfiedIcon sx={{ fontSize: "35px" }} color="error" />
      ),
      label: "Dissatisfied",
    },
    3: {
      icon: (
        <SentimentSatisfiedIcon sx={{ fontSize: "35px" }} color="warning" />
      ),
      label: "Neutral",
    },
    4: {
      icon: (
        <SentimentSatisfiedAltIcon sx={{ fontSize: "35px" }} color="success" />
      ),
      label: "Satisfied",
    },
    5: {
      icon: (
        <SentimentVerySatisfiedIcon sx={{ fontSize: "35px" }} color="success" />
      ),
      label: "Very Satisfied",
    },
  };

  function IconContainer(props) {
    const { value, ...other } = props;
    return (
      <Box sx={{ fontSize: "20px", maxWidth: "175px" }} {...other}>
        {customIcons[value].icon}
      </Box>
    );
  }

  IconContainer.propTypes = {
    value: PropTypes.number.isRequired,
  };
  const finishDialog = () => (
    <Dialog open={finishDialogOpen} onClose={handleFinishDialogClose}>
      <DialogTitle variant="h4">
        <IconButton
          aria-label="close"
          onClick={handleFinishDialogClose}
          sx={{
            position: "absolute",
            right: 5,
            top: 5,

            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon fontSize="meduim" />
        </IconButton>
      </DialogTitle>
      <Typography
        variant="h4"
        sx={{ ml: 3, mr: 3, mt: 1, textAlign: "center" }}
      >
        {" "}
        {"Please tell us about your experience"}
      </Typography>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <FormLabel
            sx={{ color: errors?.star && "red" }}
            id="demo-row-radio-buttons-group-label"
          >
            How did you experience our online investment process?
          </FormLabel>
          <StyledRating
            name="highlight-selected-only"
            IconContainerComponent={IconContainer}
            getLabelText={(value) => customIcons[value].label}
            highlightSelectedOnly
            onClick={(e) => e.target.value && setRating(e.target.value)}
          />
          <FormControl sx={{ marginBottom: !couldComplete && "3em" }}>
            <FormLabel id="demo-row-radio-buttons-group-label">
              Were you able to complete what you wanted to do?
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel
                value="true"
                control={
                  <Radio
                    checked={couldComplete}
                    onChange={() => setcouldComplete(true)}
                  />
                }
                label="Yes"
              />
              <FormControlLabel
                value="false"
                control={
                  <Radio
                    checked={!couldComplete}
                    onChange={() => setcouldComplete(false)}
                  />
                }
                label="No"
              />
            </RadioGroup>
          </FormControl>
          {!couldComplete && (
            <TextField
              {...register("couldNotComplete")}
              name="couldNotComplete"
              error={errors?.couldNotComplete}
              fullWidth
              sx={{ marginBottom: "3em" }}
              label="Please share more details with us:"
              multiline
              variant="standard"
              value={couldCompleteMessage}
              onChange={(e) => setcouldCompleteMessage(e.target.value)}
            />
          )}
          <FormControl sx={!stepsToImprove && { marginBottom: "1em" }}>
            <FormLabel id="demo-row-radio-buttons-group-label">
              Are there any steps you feel that we can improve on?
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel
                value="true"
                control={
                  <Radio
                    checked={stepsToImprove}
                    onChange={() => setStepsToImprove(true)}
                  />
                }
                label="Yes"
              />
              <FormControlLabel
                value="false"
                control={
                  <Radio
                    checked={!stepsToImprove}
                    onChange={() => setStepsToImprove(false)}
                  />
                }
                label="No"
              />
            </RadioGroup>
          </FormControl>
          {stepsToImprove && (
            <TextField
              {...register("improvements")}
              name="improvements"
              fullWidth
              error={errors?.improvements}
              sx={{ marginBottom: "3em" }}
              label="Please share more details with us:"
              multiline
              variant="standard"
              value={stepsToImproveMessage}
              onChange={(e) => setStepsToImproveMessage(e.target.value)}
            />
          )}
        </Box>
        <Box display={"flex"} justifyContent={"center"}>
          <PrimaryButton
            disabled={ratingLoading}
            onClick={() => submitRating()}
          >
            Submit Feedback{" "}
            {ratingLoading && (
              <CircularProgress
                sx={{ ml: 1, mt: "auto", mb: "auto" }}
                size={20}
                color="inherit"
              />
            )}
          </PrimaryButton>
        </Box>
      </DialogContent>
    </Dialog>
  );

  const thankYouDialog = () => (
    <Dialog
      fullWidth
      sx={{ textAlign: "center" }}
      open={thankYouDialogOpen}
      onClose={handleCloseThankYouDialog}
    >
      <TaskAltOutlinedIcon
        color={"success"}
        sx={{ margin: "auto", mt: 3, width: "200px", height: "200px" }}
      />
      <DialogTitle variant="h4" sx={{ pb: 0.1 }}>
        {finalDialogText}
      </DialogTitle>
      <br />
      <DialogContent>
        <PrimaryButton
          onClick={() => goToWebsite()}
          href={"https://fairtree.com/"}
          target="_blank"
        >
          Go to website
        </PrimaryButton>
        <PrimaryButton
          onClick={() => handleConfirmReset({ startAnother: true })}
        >
          Start another investment
        </PrimaryButton>
      </DialogContent>
    </Dialog>
  );

  const FacebookCircularProgress = () => {
    return (
      <Box sx={{ position: "relative" }}>
        <CircularProgress
          variant="determinate"
          sx={{
            color: (theme) =>
              theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
          }}
          size={55}
          thickness={5}
          value={100}
        />
        <CircularProgress
          variant="determinate"
          disableShrink
          sx={{
            animationDuration: "550ms",
            position: "absolute",
            left: 0,
            [`& .${circularProgressClasses.circle}`]: {
              strokeLinecap: "round",
            },
          }}
          value={stepPercent}
          size={55}
          thickness={5}
        />
      </Box>
    );
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Stepper nonLinear activeStep={stepper.active} alternativeLabel>
        {!isMobile &&
          stepper.steps.map((step, index) => (
            <Step key={index} completed={stepper.steps[index].completed}>
              <StepButton
                color="inherit"
                disabled={index > completedSteps() - 1}
                onClick={handleStep(index)}
                sx={{ fontSize: 15 }}
              >
                <Typography variant="subtitle1">{step.name}</Typography>
              </StepButton>
            </Step>
          ))}
      </Stepper>

      <div>
        <React.Fragment>
          {props.getStepContent()}
          {userId && (
            <Box display={"flex"} mt={0} justifyContent={"end"}>
              {`Signed in as: ${submitionData.email}`}
            </Box>
          )}
          {showButtons() && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                pt: 2,
                justifyContent: "center",
              }}
            >
              {!isLastStep() && (
                <Button
                  color="primary"
                  disabled={
                    stepper.active === 0 || creatingSecureProcess || submitting
                  }
                  onClick={handleBack}
                  sx={{ mr: 1 }}
                  size="medium"
                >
                  Back
                </Button>
              )}
              {!isLastStep() && (
                <Button
                  onClick={handleStartOver}
                  sx={{ mr: 1 }}
                  size="medium"
                  disabled={creatingSecureProcess || submitting}
                >
                  Start Over
                </Button>
              )}
              {stepper.active !== 1 && (
                <Button
                  size="medium"
                  variant={"contained"}
                  onClick={handleNext}
                  sx={{
                    mr: 1,
                    "&.Mui-disabled": {
                      background: "#CC6323",
                      color: "#fff",
                    },
                  }}
                  disabled={creatingSecureProcess || submitting}
                >
                  {isLastStep()
                    ? "Finish"
                    : props.nextAltText
                    ? props.nextAltText
                    : "Next"}
                </Button>
              )}
              {stepper.active > 1 && stepper.active < 4 && <SaveProcess />}
            </Box>
          )}

          <Dialog
            open={confirmResetOpen}
            onClose={handleCloseReset}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Start Over?"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to start over?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseReset}>Cancel</Button>
              <Button onClick={handleConfirmReset} autoFocus>
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      </div>

      {finishDialog()}
      {thankYouDialog()}

      {/* <SupportBox /> */}
    </Box>
  );
}
